import React from 'react'
import styled from '@emotion/styled'
import { ColorBaseGreyDark } from 'assets/styles/variables'

const Svg = styled('svg')<{ customColor?: string }>`
    fill: ${(props) => props.customColor || ColorBaseGreyDark};
    height: 15px;
    width: 15px;
    transition: fill 0.2s ease;
    margin-left: 2px;
`

type Props = {
    title?: string
    className?: string
    customColor?: string
}

export const LocationIcon: React.FC<Props> = ({ className, customColor }) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className={className}
        customColor={customColor}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.9975 0C6.77565 0 4.6448 0.882627 3.07371 2.45371C1.50262 4.0248 0.619995 6.15565 0.619995 8.3775C0.619995 12.0456 2.63873 15.9232 4.55971 18.8046C5.53157 20.2624 6.50213 21.4997 7.22954 22.3726C7.59358 22.8095 7.89759 23.1561 8.11157 23.3945C8.21859 23.5138 8.30315 23.606 8.36152 23.6691C8.39071 23.7006 8.41335 23.7248 8.42898 23.7415L8.44712 23.7607L8.45214 23.766L8.45361 23.7676L8.45409 23.7681C8.45426 23.7682 8.4544 23.7684 8.9975 23.2511L8.4544 23.7684C8.59595 23.917 8.79224 24.0011 8.9975 24.0011C9.20276 24.0011 9.39905 23.917 9.5406 23.7684L8.9975 23.2511C9.5406 23.7684 9.54074 23.7682 9.54091 23.7681L9.54139 23.7676L9.54286 23.766L9.54788 23.7607L9.56602 23.7415C9.58165 23.7248 9.60429 23.7006 9.63348 23.6691C9.69185 23.606 9.77641 23.5138 9.88343 23.3945C10.0974 23.1561 10.4014 22.8095 10.7655 22.3726C11.4929 21.4997 12.4634 20.2624 13.4353 18.8046C15.3563 15.9232 17.375 12.0456 17.375 8.3775C17.375 6.15565 16.4924 4.0248 14.9213 2.45371C13.3502 0.882627 11.2194 0 8.9975 0ZM9.61313 21.4123C9.37857 21.6938 9.17041 21.9358 8.9975 22.1329C8.82458 21.9358 8.61643 21.6938 8.38187 21.4123C7.67912 20.5691 6.7428 19.3751 5.80779 17.9726C3.91501 15.1334 2.12 11.5742 2.12 8.3775C2.12 6.55348 2.84459 4.80416 4.13437 3.51437C5.42415 2.22459 7.17347 1.5 8.9975 1.5C10.8215 1.5 12.5708 2.22459 13.8606 3.51437C15.1504 4.80416 15.875 6.55348 15.875 8.3775C15.875 11.5742 14.08 15.1334 12.1872 17.9726C11.2522 19.3751 10.3159 20.5691 9.61313 21.4123ZM6.6959 8.37691C6.6959 7.1061 7.7261 6.07591 8.99691 6.07591C10.2677 6.07591 11.2979 7.1061 11.2979 8.37691C11.2979 9.64772 10.2677 10.6779 8.99691 10.6779C7.7261 10.6779 6.6959 9.64772 6.6959 8.37691ZM8.99691 4.57591C6.89767 4.57591 5.1959 6.27767 5.1959 8.37691C5.1959 10.4761 6.89767 12.1779 8.99691 12.1779C11.0961 12.1779 12.7979 10.4761 12.7979 8.37691C12.7979 6.27767 11.0961 4.57591 8.99691 4.57591Z"
        />
    </Svg>
)
